<template>
    <div class="inspector" ref="inspectorDiv">
        <div class="inspector-toolbar">
            <input @keyup.enter="addInspection" type="text" class="var-input" placeholder="Variable o expresión" v-model="newInspection">
            <select v-model="context">
                <option v-for="(value, key) in outline">{{ key }}</option>
            </select>
            <PsButton :small="true" :model="'Agregar'" :disabled="newInspection === '' || context === ''" @click="addInspection" :icon="'fa-plus'" :icon-color="'fa-green'"></PsButton>
            <PsButton style="float: right; margin-top: 4px; margin-left: 10px;" :small="true" :model="'Borrar Todo'" @click="clearAll" :icon="'fa-trash'" :icon-color="'fa-red'"></PsButton>
            <PsButton style="float: right; margin-top: 4px;" :small="true" :model="'Limpiar Valores'" @click="clearValues" :icon="'fa-times'" :icon-color="'fa-yellow'"></PsButton>
        </div>
        <div v-if="tables.length > 0">
            <div v-for="table in tables">
                <div>
                    <table class="var-table" >
                        <tr>
                            <th v-bind:colspan="table.headers.length + 1" class="table-header">{{ table.context }}</th>
                        </tr>
                      <tr>
                        <th>L&iacute;nea</th>
                        <th v-for="header in table.headers" class="with-actions" v-bind:class="{'invalid-inspection': !header.isValid}" @click="edit.show=true; edit.ins=header; edit.id = header.id">
                            {{ header.expression }}
                        </th>
                      </tr>
                      <tr v-for="row in table.rows">
                        <td v-if="row[0].value !== -1" v-bind:class="{'inspection-modified': colValue.isModified}" v-for="colValue in row">
                            {{ colValue.value }}
                        </td>
                        <td v-else style="background: #999; min-height: 6px;"></td>
                      </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="inspector-empty" v-else>
            No hay inspecciones.
        </div>
        <div class="inspector-legend">Haga click en la columna para ver opciones sobre la expresión. No se pueden usar Funciones que lean datos del teclado.</div>
        <div v-if="edit.show" class="detail-popup-overlay">
            <div class="detail-popup-wrapper">
                <h2>{{ edit.ins.expression }}</h2>
                <div class="detail-popup-type">{{ getExpressionType(edit.ins.type) }}</div>
                <div style="margin: 5px;"><PsButton :model="'Eliminar'" @click="removeInspection(edit.id)" :icon="'fa-times'" :icon-color="'fa-red'"></PsButton></div>
                <div style="margin: 5px; margin-top: 20px;"><PsButton :model="'Cancelar'" @click="edit.show=false" :icon="'fa-arrow-left'" :icon-color="'fa-green'"></PsButton></div>
                <div v-if="!edit.ins.isValid" style="text-align: left;">
                    <div style="background: #F0D0D0;">La expresión no es válida.</div>
                    <div>Errores:</div>
                    <div>
                        <div v-for="err in edit.ins.errors">{{ err }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from './../../EventBus.js'
    import PsButton from './../Widget/PsButton'
    export default {
        name: 'Inspector',
        props: ['id', 'outline', 'inspections'],
        components: {
            PsButton
        },
        mounted () {
            this.registerEventHandlers(this.id)
            window.vms[this.id].setInspectionListener((line, context, newValues) => {
                this.handleNewValue(line, context, newValues)
            })
            window.vms[this.id].setContextEndListener((context) => {
                this.handleContextEnd(context)
            })
            this.updateTable()
        },
        watch: {
            values () {
                this.$refs.inspectorDiv.scrollTop = this.$refs.inspectorDiv.scrollHeight
            },
            inspections () {
                this.updateTable()
            },
            outline () {
                if (this.context === '' || this.outline[this.context] === undefined) {
                    for (let c in this.outline) {
                        if (this.outline[c].kind === 'main') {
                            this.context = c
                            break
                        }
                    }
                }
            }
        },
        methods: {
            getExpressionType (type) {
                let typeString = 'Tipo Desconocido'
                try {
                    if (type !== null && type !== undefined) {
                        if (type.isInt()) {
                            typeString = 'Tipo Entero'
                        }
                        if (type.isFloat()) {
                            typeString = 'Tipo Real'
                        }
                        if (type.isChar()) {
                            typeString = 'Tipo Caracter'
                        }
                        if (type.isBool()) {
                            typeString = 'Tipo Logico'
                        }
                        if (type.isError()) {
                            typeString = 'Tipo Error'
                        }
                    }
                } catch (e) {}
                return typeString
            },
            handleNewValue (line, context, newValues) {
                let lastRow = null
                if (this.inspections[context] === undefined) {
                    console.log('New value for unexistent context.', line, context, newValues)
                    return
                }
                if (this.contextValues[context] === undefined) {
                    this.contextValues[context] = []
                }
                // Create first row or new
                if (this.contextValues[context].length > 0) {
                    // Check for changes. Only create new row if at least one inspection has a new value.
                    let hasChanges = false
                    lastRow = this.contextValues[context][this.contextValues[context].length - 1]
                    for (let i in newValues) {
                        let displayValue = this.getDisplayValue(newValues[i].value) + ''
                        if (lastRow.values[newValues[i].id] === undefined || lastRow.values[newValues[i].id].value !== displayValue) {
                            hasChanges = true
                            break
                        }
                    }
                    if (!hasChanges) {
                        return
                    }
                    // Duplicate last row
                    let newRow = {
                        line: line,
                        values: {}
                    }
                    for (let inspectionId in lastRow.values) {
                        newRow.values[inspectionId] = {
                            value: lastRow.values[inspectionId].value,
                            isModified: false
                        }
                    }
                    this.contextValues[context].push(newRow)
                    lastRow = this.contextValues[context][this.contextValues[context].length - 1]
                } else {
                    // Create first row
                    let values = {}
                    for (let i in this.inspections[context]) {
                        values[i] = '-'
                    }
                    this.contextValues[context].push({
                        line: line,
                        values
                    })
                    lastRow = this.contextValues[context][this.contextValues[context].length - 1]
                }

                // Update inspection values
                for (let i in newValues) {
                    let displayValue = this.getDisplayValue(newValues[i].value) + ''
                    let isModified = lastRow.values[newValues[i].id] === undefined || lastRow.values[newValues[i].id].value !== displayValue
                    lastRow.values[newValues[i].id] = {
                        value: displayValue,
                        isModified: isModified
                    }
                }
                this.updateTable()
            },
            handleContextEnd (context) {
                if (!context || this.inspections[context] === undefined) {
                    // console.log('End unexistent context', context)
                    return
                }

                if (this.contextValues[context] === undefined) {
                    this.contextValues[context] = []
                }

                this.contextValues[context].push({
                    line: -1,
                    values: {}
                })
            },
            updateTable () {
                this.tables = []
                for (let c in this.inspections) {
                    let table = {
                        context: c,
                        headers: [],
                        rows: []
                    }
                    for (let e in this.inspections[c]) {
                        table.headers.push(this.inspections[c][e])
                    }
                    for (let val in this.contextValues[c]) {
                        let row = [{
                            value: this.contextValues[c][val].line,
                            isModified: false
                        }]
                        for (let header in table.headers) {
                            if (this.contextValues[c][val].values[table.headers[header].id] !== undefined) {
                                row.push(this.contextValues[c][val].values[table.headers[header].id])
                            } else {
                                row.push({
                                    value: '',
                                    isModified: false
                                })
                            }
                        }
                        table.rows.push(row)
                    }
                    this.tables.push(table)
                }
            },
            clearAll () {
                if (window.confirm('¿Seguro que desea eliminar todas las inspecciones?')) {
                    EventBus.$emit('inspector.remove.all.' + this.id)
                }
            },
            registerEventHandlers (id) {
                EventBus.$on('inspector.clear.' + id, this.clearValues)
                EventBus.$on('inspector.updated.' + id, this.updateTable)
            },
            clearValues () {
                this.contextValues = {}
                this.updateTable()
            },
            removeInspection (id) {
                EventBus.$emit('inspector.remove.' + this.id, id)
                this.edit.show = false
            },
            addInspection () {
                if (this.newInspection === '' || this.context === '') return
                EventBus.$emit('inspector.new.add.' + this.id, this.context, this.newInspection)
                this.newInspection = ''
            },
            getDisplayValue (valueType) {
                if (valueType === undefined) {
                    return '-'
                } else if (valueType === null) {
                    return '⊥'
                }
                return this.cloneValue(valueType.type, valueType.value)
            },
            cloneValue (type, value) {
                let result
                if (type === null || value === null) return
                if (type === undefined || value === undefined) return
                if (type.isInt()) {
                    result = parseInt(value.toString())
                } else if (type.isFloat()) {
                    result = value.toString()
                    if (result.indexOf('.') === -1) {
                        result += '.0'
                    }
                } else if (type.isChar()) {
                    result = String.fromCharCode(value)
                } else if (type.isString()) {
                    result = '' + value
                } else if (type.isBool()) {
                    if (value === true) {
                        result = 'Verdadero'
                    } else if (value === false) {
                        result = 'Falso'
                    } else {
                        result = 'Error'
                    }
                }
                return result
            }
        },
        data () {
            return {
                newInspection: '',
                contextValues: {},
                context: '',
                tables: [],
                edit: {
                    show: false,
                    expression: ''
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .detail-popup-type {
        font-weight: bold;
        margin-bottom: 30px;
    }
    .detail-popup-wrapper {
        position: absolute;
        left: 50px;
        top: 50px;
        bottom: 50px;
        right: 50px;
        background: #f0f0f0;
        padding: 10px;
        border: 1px solid #999;
        text-align: center;
    }
    .detail-popup-overlay {
        position: absolute;
        left: 0px;
        top: 0px;
        bottom: 0px;
        right: 0px;
        background: rgba(128,128,128,0.8);
    }
    input.var-input {
        height: 18px;
        font-size: 12px;
        line-height: 18px;
        padding: 2px;
        margin: 0px;
        border: 1px solid #AAA;
        border-radius: 2px;
    }
    .inspector {
        font-family: "Inconsolata", monospace;
        width: calc(100% - 8px);
        height:  calc(100% - 28px);
        overflow-y: auto;
        overflow-x: auto;
        background: #f0f0f0;
        color: #444;
        font-size: 14px;
        padding-left: 4px;
        padding-right: 4px;
        padding-top: 4px;
        position: relative;
    }
    .inspector-toolbar {
        margin-bottom: 3px;
        padding-bottom: 10px;
        border-bottom: 1px solid #999;
        width: 100%;
        display: block;
        overflow: hidden;
    }
    .invalid-inspection {
        color: red;
        text-decoration: line-through;
    }
    .var-table {
        width: 100%;
        border: 0px;
        border-collapse: collapse;
        background-color: #F8F8F8;
        margin-bottom: 22px;
    }
    .var-table tr th {
        font-weight: normal;
        background-color: #DADADA;
        border: 1px solid #999;
    }
    .var-table tr th.table-header {
        background-color: #DEF;
        padding: 2px;
        font-weight: bold;
        text-align: center;
    }
    .var-table tr th.with-actions {
        cursor: pointer;
    }
    .var-table tr th.with-actions:hover {
        background-color: #EFB0B0;
    }
    .var-table tr td {
        font-weight: normal;
        border: 1px solid #999;
        text-align: center;
    }
    .inspector-legend {
        display: block;
        position: relative;
        width: calc(100% - 18px);
        font-size: 14px;
        text-align: center;
        color: #555;
        margin-bottom: 15px;
    }
    .inspector-empty {
        padding: 10px;
        margin-bottom: 20px;
        width: calc(100% - 18px);
        text-align: center;
    }
    .inspection-modified {
        color: #F33;
    }
</style>


// WEBPACK FOOTER //
// src/Components/CodeEditor/Inspector.vue